import { render } from "./Registration.vue?vue&type=template&id=481f6efe&scoped=true&ts=true"
import script from "./Registration.vue?vue&type=script&lang=ts"
export * from "./Registration.vue?vue&type=script&lang=ts"

import "./Registration.vue?vue&type=style&index=0&id=481f6efe&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481f6efe"]])

export default __exports__